module.exports = __webpack_public_path__ + "static/img/15.df439dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/15.png
// module id = UYdJ
// module chunks = 2